<div class="container" [class.mat-elevation-z8]="true">
    <div class="tab">
        <button mat-mini-fab [disabled]="abaDependenteDisable" color="primary">1</button>
        <p>Alunos</p>
    </div>
    <div class="tab">
        <button mat-mini-fab [disabled]="abaListaMaterialDisable" color="primary">2</button>
        <p>Lista de Materiais</p>
    </div>
    <div class="tab">
        <button mat-mini-fab [disabled]="abaEnderecoEntregaDisable" color="primary">3</button>
        <p>Endereço de Entrega</p>
    </div>
    <div class="tab">
        <button mat-mini-fab [disabled]="abaFormaPagamentoDisable" color="primary">4</button>
        <p>Forma de Pagamento</p>
    </div>
    <div class="tab">
        <button mat-mini-fab [disabled]="abaFinalizacaoDisable" color="primary">5</button>
        <p>Finalização</p>
    </div>
</div>